import { createSlice } from "@reduxjs/toolkit";

const appDataSlice = createSlice({
  name: "appDataSlice",
  initialState: {
    appData: null,
  },
  reducers: {
    setDataAction(state, { payload }) {
      state.appData = payload;
    },

    updateAppDataAction(state, { payload }) {
      const { key, value } = payload;
      state.appData[key] = value;
    },
  },
});

export default appDataSlice.reducer;

export const { setDataAction, updateAppDataAction } = appDataSlice.actions;
